import styled from 'styled-components';
import IndexLayout from '../layouts';
import * as React from 'react';
import { Helmet } from 'react-helmet';
import { NavBar } from '../components/ui';
import { BottomNavSegment } from '../components/PageSegments';
import favicon from '../content/img/icon/favicon.ico';
import PurposeAtBase10 from '../components/PageSegments/purpose/PurposeAtBase10';
import OrganizationCollaborations from '../components/PageSegments/purpose/OrganizationCollaborations';
import DownloadReportForm from '../components/PageSegments/purpose/DownloadReportForm';

export default () => {
  return (
    <IndexLayout>
      <Helmet>
        <title>Purpose - Base10</title>
        <link rel="stylesheet" type="text/css" href="/global.css" />
        <link rel="icon" href={favicon} />
        <meta name="description" content="Investing in Automation for the Real Economy" />
        <meta charSet="UTF-8" />
        <html lang="en-US" />
        <meta name="theme-color" content="#1a1a1a" />
        <link rel="canonical" href="https://base10.vc/purpose/" />
      </Helmet>
      <Main>
        <NavBar invert={false} />
        <PurposeAtBase10 />
        <OrganizationCollaborations />
        <DownloadReportForm />
        <BottomNavSegment />
      </Main>
    </IndexLayout>
  );
};

const Main = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;
